// extracted by css-extract-rspack-plugin
export default {"checks":"CandidateTimeline_checks__-XTkH"};